"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Interpreter = void 0;
const modl_parser_1 = require("modl-parser");
const ModlToJson_1 = require("./ModlToJson");
class Interpreter {
    interpretToJsonString(s) {
        const jsonObject = this.interpretToJsonObject(s);
        return JSON.stringify(jsonObject);
    }
    interpretToPrettyJsonString(s) {
        const jsonObject = this.interpretToJsonObject(s);
        return JSON.stringify(jsonObject, undefined, 4);
    }
    interpretToJsonObject(s) {
        const modl = this.interpret(s);
        return ModlToJson_1.modlToJson(modl);
    }
    interpret(s) {
        return modl_parser_1.parser(s);
    }
}
exports.Interpreter = Interpreter;
//# sourceMappingURL=Interpreter.js.map